<template>
	<div>
		<header>
		    <i></i>
		    <a class="back" @click="goBack">东方号</a>
		</header>
		<div class="stepContainer">
		    <div class="step">
		        <div class="icon-step active"></div>
		        <div class="name">账号注册</div>
		    </div>
		    <div class="step-line bg-red"></div>
		    <div class="step">
		        <div class="icon-step active"></div>
		        <div class="name">类型选择</div>
		    </div>
		    <div class="step-line bg-disabled"></div>
		    <div class="step">
		        <div class="icon-step bg-disabled"></div>
		        <div class="name">资料填写</div>
		    </div>
		</div>
		<div class="page" id="selectType">
		    <div class="title f-disabled"><i class="title-icon"></i>非个人类型入驻，请前往PC端（tt.cn）提交资料</div>
		    <div class="type-list container f-small">
		        <ul>
		            <li>
		                <div class="type-img type-img-person bg-red"></div>
		                <div class="type-info">
		                    <div class="name f-default f-big">个人</div>
		                    <p class="details f-disabled">适合垂直领域的专家、意见领袖、评论家及自媒体申请。</p>
		                </div>
		                <div class="type-operate">
		                    <div @click="crzType($event, 1)" :class="btnDisabled ? 'disabled' : ''">入驻</div>
		                </div>
		            </li>
		            <li>
		                <div class="type-img type-img-media bg-yellow"></div>
		                <div class="type-info">
		                    <div class="name f-default f-big">媒体</div>
		                    <p class="details f-disabled">适合报纸、杂志、电视、电台、通讯社或其它生产内容为主的组织机构。</p>
		                </div>
		                <div class="type-operate">
		                    <div :class="!btnDisabled ? 'disabled' : ''">入驻</div>
		                </div>
		            </li>
		            <li>
		                <div class="type-img type-img-company bg-green"></div>
		                <div class="type-info">
		                    <div class="name f-default f-big">企业</div>
		                    <p class="details f-disabled">适合企业、公司、分支机构，企业相关的品牌与服务等。</p>
		                </div>
		                <div class="type-operate">
		                    <div :class="!btnDisabled ? 'disabled' : ''">入驻</div>
		                </div>
		            </li>
		            <li>
		                <div class="type-img type-img-gov bg-blue"></div>
		                <div class="type-info">
		                    <div class="name f-default f-big">国家机构</div>
		                    <p class="details f-disabled">国内外各级、各类政府机构、事业单位、具有行政职能的社会机构等。</p>
		                </div>
		                <div class="type-operate">
		                    <div :class="!btnDisabled ? 'disabled' : ''">入驻</div>
		                </div>
		            </li>
		            <li>
		                <div class="type-img type-img-other bg-blue1"></div>
		                <div class="type-info">
		                    <div class="name f-default f-big">其他组织</div>
		                    <p class="details f-disabled">适合各类公共场馆、公益机构、学校、社团、民间组织等机构团体。</p>
		                </div>
		                <div class="type-operate">
		                    <div :class="!btnDisabled ? 'disabled' : ''">入驻</div>
		                </div>
		            </li>
		        </ul>
		    </div>
		</div>
		<footer class="b-default copyright">
		    <p>©上海嵩智文化传播有限公司（tt.cn）版权所有 </p>
		</footer>
	</div>
</template>
<script>
	import {crzType, getuserinfo,register_two} from './../../axios/api.js'
	export default {
		name: 'RegistType',
		data (){
			return {
				btnDisabled: false,
			}
		},
		mounted(){
		//	this.getRouteData();
		},
		methods:{
			getRouteData (){
				// 获取用户信息
				// if(this.$route.query.user.mediaHeadPic){
				// 	this.userInfo = this.$route.query.user;
				// }
				let that = this;
                getuserinfo().then(result => {
                	// if(result.stat != 1){
                	// 	that.$router.push({path: '/Login'})
                	// 	return;
                	// }
                    // if (result.user) {
					// 	if(result.user.registstep == 3){
					// 		that.$router.push({path: '/Homepage'})
					// 	}
                    // }
                })
            },
			goBack (){
				this.$router.go(-1);
			},
			goRegistData (){
				this.$router.push({path: '/RegistData'})
			},
			crzType (event, val){
				let account = localStorage.getItem('accountPhone');
				 let params = {
                    entryType: val,
                    account: account
                }
				register_two(params).then(res =>{
					if(res.code == "0"){
					  this.goRegistData();	
					}else{
						this.$layer.dialog({
									content: res.msg,
									time: 2000
						})
					}
				}).catch(err =>{

				});
			},
		}
	}	
</script>
<style scoped>
	@import "./../../common/css/reg.css";
	@import "./../../common/css/h5Base.css";
    input[type="checkbox"]{
        width: .32rem;
        height: .32rem;
    }
    input::-webkit-input-placeholder {
		color: #999;
	}
	.main h3 {
		font-weight: bold;
	}
	
</style>


// WEBPACK FOOTER //
// src/pages/regist/registType.vue